module.exports = __webpack_public_path__ + "static/img/welcome-img-1.4f751d8.png";